import {HiShieldCheck} from "react-icons/hi";
import {MdCancel, MdAnalytics} from "react-icons/md";

const data=[
    {
        icon:<HiShieldCheck/>,
        heading:"Best interrest rates on the market",
        detail:"Exercitation in fugiat est ut ad ea cupidatat occaecat consequat est minim minimm esse tempor laborum consequat esse adipisicing eu reprehenderit enim.",
    },
    {
        icon:<MdCancel/>,
        heading:"Prevent unstable price",
        detail:"Exercitation in fugiat est ut ad ea cupidatat occaecat consequat est minim minimm esse tempor laborum consequat esse adipisicing eu reprehenderit enim.",
    },
    {
        icon:<MdAnalytics/>,
        heading:"Best price in the market",
        detail:"Exercitation in fugiat est ut ad ea cupidatat occaecat consequat est minim minimm esse tempor laborum consequat esse adipisicing eu reprehenderit enim.",
    },
];
export default data;